<div class="box ml-2 mr-2">
  <div class="box-header">

    <div class="row flex-align-center px-3 mt-3 mb-2">
      <div class="col-sm-12 text-sm-right mb-sm-2">
        <button [disabled]="addUserButton" mat-raised-button matTooltip="{{'Add_User_Tool_Tip' | translate}}" color="primary" (click)="addUser()">
          <mat-icon>person_add</mat-icon>
          {{'Add User' | translate}}
        </button>
      </div>
      <div class="ml-auto">
        <form [formGroup]="storeUserForm">
          <label class="font-weight-500">{{'Filters' | translate}} : </label>
          <mat-radio-group formControlName="status" aria-label="Select an option">
            <mat-radio-button value="" matTooltip="{{'All_Users_Tool_Tip' | translate}}"  class="mx-2" color="primary">{{'All Users' | translate}}</mat-radio-button
              >
              <mat-radio-button value="Y" matTooltip="{{'Active_Tool_Tip' | translate}}" class="mx-2" color="primary">{{'Active' | translate}}</mat-radio-button
                >
                <mat-radio-button value="N" matTooltip="{{'Inactive_Tool_Tip' | translate}}" class="mx-2" color="primary">{{'Inactive' | translate}}</mat-radio-button
                  >
                </mat-radio-group>
              </form>
            </div>
          </div>
          <div class="grid-filter">
            <div class="actions">
              <div class="row">
                <div class="col-md-6 flex-align-center">
                  <form [formGroup]="storeUserForm">
                    @if (userData && userData.roleId>1) {
                      <mat-form-field appearance="outline">
                        <mat-label>{{'Store #' | translate}}</mat-label>
                        <mat-select formControlName="storeNumber" disableOptionCentering>
                          @for (store of stores; track store) {
                            <mat-option [value]="store.storeNumber">
                              {{store.banner}}-{{ store.sdmStoreNumber}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }

                    @if (userData && userData.roleId===1) {
                      <mat-form-field appearance="outline">
                        <mat-label>{{'Store #' | translate}}</mat-label>
                        <input type="text"
                          required
                          aria-label="Number"
                          matInput
                          maxlength="10"
                          (blur)="onchangeStore()"
                          formControlName="storeNumber"
                          [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)" (optionSelected)='getSelectedStore($event.option.value)'>
                          @for (option of filteredStoreOptions | async; track option) {
                            <mat-option [value]="option.storeNumber">
                              {{option.banner}}-{{ option.sdmStoreNumber}}
                            </mat-option>
                          }
                          <!-- <mat-option *ngFor="let store of stores" [value]="store.storeNumber" >
                          {{store.banner}}-{{ store.sdmStoreNumber}}
                        </mat-option> -->
                      </mat-autocomplete>
                      <!-- <mat-select formControlName="storeNumber" disableOptionCentering>
                      <mat-option *ngFor="let store of stores" [value]="store.storeNumber">
                        {{store.banner}}-{{ store.sdmStoreNumber}}-{{ store.storeNumber}}
                      </mat-option>
                    </mat-select> -->
                  </mat-form-field>
                }
              </form>
              <button mat-raised-button (click)="getUsersData()" [disabled]="!storeUserForm.valid"
                class="ml-2 mt-2 ml-sm-auto">
                {{'Filter' | translate}}
              </button>

            </div>
            <div class="col-md-6 flex-align-center justify-md-right">
              <mat-form-field>
                <mat-label>{{'Search' | translate}}</mat-label>
                <input matInput placeholder="Placeholder" (keyup)="applyFilter($event.target.value)"/>
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-body">
      <div class="box">
        <div class="box-body " style="margin-top: 8px !important;">
          <mat-table class="order-summary-table" [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">
            <!-- Position Column -->
            <ng-container matColumnDef="userid">
              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> {{'User ID' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.upn }} </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="firstname">
              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> {{'First Name' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.firstName }} </mat-cell>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="lastname" >
              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> {{'Last Name' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.lastName }} </mat-cell>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="license">
              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> {{'Licence #' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.license }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="userrole">
              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> {{'User Role' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.roleName | translate }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> {{'Status' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ (element.userStatus==='Y'?'Active':'Inactive' ) | translate | uppercase  }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef > {{'Action' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <button mat-icon-button matTooltip="{{'ViewDetailsTooltip' | translate}}" (click)="editUser(element,'edit')">
                  <mat-icon>visibility</mat-icon>

                </button>

              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>



        </div>



      </div>
    </div>
    <div class="box-footer">
      <mat-paginator [length]="resultsLength" [pageSize]="15" showFirstLastButtons></mat-paginator>
    </div>
  </div>
